import { Col, Row } from 'antd'
import Select from 'components/Select'
import TreeSelect from 'components/TreeSelect'
import CalendarIcon from 'components/icons/CalendarIcon'
import CheckListIcon from 'components/icons/CheckListIcon'
import { CommonToggle, ToggleContainer } from 'modules/Drive/Style/style'
import React ,{ useState, useEffect } from 'react'
import { COLORS } from 'theme'
import {
  Container,
  FilterFolderAbsolute,
  FilterFolderRelative,
  FilterFolderAbsolute1,
  RightSticky,
} from './Style'

import List from '../../ListView/List'
import EventSearch from '../../ListView/List/Components/EventSearch'
import WeekView from '../../WeekView'

const EventDetails = ({
  currentWeekStart,
  currentWeekEnd,
  calendarRef,
  selectedEvent,
  setSelectedEvent,
  departmentOptions,
  currentToggle,
  handleOccurrenceClick,
  eventList,
  handleToggleChange,
  degreeOptions,
  state,
  setState,
  fetchEventsList,
  handleSingleEventClick,
  handleCategoryChange,
  handleYearChange,
  selectedCategory,
  handleDegreeChange,
  selectedDegree,
  handleSearch,
  handleSortByChange,
  setIsDrawerVisible,
  selectedYear,
  isDrawerVisible,
  uniqueCategories,
  uniqueYears,
  handleDepartmentChange,
  selectedDepartment,
  // Specialization props - commented out as no longer needed
  // selectedSpecialization,
  // handleSpecializationChange,
  // specializationOptions,
  handleDrawerClose, 
  setRenderState,
  departmentOptionSet
}) => {
  const BREAKPOINT = 1250; // Pixels
  const [treeSelectWidth, setTreeSelectWidth] = useState('160px');

  useEffect(() => {
    const updateWidth = () => {
      if (window.innerWidth < BREAKPOINT) {
        setTreeSelectWidth('120px');
      } else {
        setTreeSelectWidth('160px');
      }
    };
    updateWidth(); // Check the width initially
    window.addEventListener('resize', updateWidth);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('resize', updateWidth);
  }, []);
  return (
    <>
      {state.eventStatus == 'DRAFT' ? null : (
        <Container spaceBetween>
          <Row style={{ gap: '10px', flexWrap: 'nowrap' }}>
            <Col style={{ marginTop: '-10px' }}>
              <FilterFolderRelative>
                <FilterFolderAbsolute>Degree</FilterFolderAbsolute>

                <TreeSelect
                  width={treeSelectWidth}
                  showArrow={true}
                  filterTreeNode={false}
                  treeData={degreeOptions}
                  treeCheckable={true}
                  placeholder="Select Degree"
                  maxTagCount={0}
                  showSearch={false}
                  placeholderSize={'12px'}
                  onChange={handleDegreeChange}
                  treeDefaultExpandAll={true}
                  removeTreeIndent={true}
                  shadowBox
                  // onSearch={data => handleDegreeSearch(data)}
                  height={'auto'}
                  treeNodeFilterProp="title"
                  autoClearSearchValue={false}
                  value={selectedDegree}
                  listHeight={180}
                  // allowClear={isEditRoleOnView ? false : true}
                />
              </FilterFolderRelative>
            </Col>

            <Col style={{ marginTop: '-10px' }}>
              <FilterFolderRelative>
                <FilterFolderAbsolute
                // disabled={domainValue === '' ? true : false}
                >
                  Depart.
                </FilterFolderAbsolute>

                <TreeSelect
                 width={treeSelectWidth}
                  showArrow={true}
                  filterTreeNode={false}
                  treeData={departmentOptionSet || []}
                  treeCheckable={true}
                  placeholder="Select Department"
                  maxTagCount={0}
                  placeholderSize={'12px'}
                  showSearch={false}
                  onChange={handleDepartmentChange}
                  treeDefaultExpandAll={true}
                  removeTreeIndent={true}
                  shadowBox
                  disabled={selectedDegree?.length === 0}
                  // onSearch={data => handleDepartmentSearch(data)}
                  height={'auto'}
                  value={selectedDepartment}
                  treeNodeFilterProp="title"
                  autoClearSearchValue={false}
                  listHeight={180}
                  // allowClear={isEditRoleOnView ? false : true}
                />
              </FilterFolderRelative>
            </Col>
            
            <Col>
              <FilterFolderRelative>
                <FilterFolderAbsolute1
                // disabled={domainValue === '' ? true : false}
                >
                  Passing year
                </FilterFolderAbsolute1>

                <Select
                  className="fixed-height-select"
                  width={treeSelectWidth}
                  showSearch={false}
                  allowClear={false}
                  showArrow={true}
                  OptionData={uniqueYears}
                  placeholder="Select Year"
                  maxTagCount={0}
                  valueParam="value"
                  nameParam="value"
                  colorstyle={true}
                  value={selectedYear}
                  onChange={handleYearChange}
                  mode="multiple"
                  // filterOption={(input, option) => {
                  //   const childrenString = option.children
                  //     .toString()
                  //     .toLowerCase()
                  //   return childrenString.includes(input.toLowerCase())
                  // }}
                  listHeight={180}
                  boxShadow="rgba(123, 97, 255, 0.15) 0px 2px 6px 0px"
                />
              </FilterFolderRelative>
            </Col>
            <Col style={{ marginTop: '-10px' }}>
              <FilterFolderRelative>
                <FilterFolderAbsolute
                // disabled={domainValue === '' ? true : false}
                >
                  Event cat.
                </FilterFolderAbsolute>
                <TreeSelect
                  showArrow={true}
                  filterTreeNode={false}
                  treeData={uniqueCategories}
                  treeCheckable={true}
                  placeholder="Show all"
                  maxTagCount={0}
                  placeholderSize={'12px'}
                  showSearch={false}
                  onChange={handleCategoryChange}
                  treeDefaultExpandAll={true}
                  removeTreeIndent={true}
                  shadowBox
                  height={'auto'}
                  value={selectedCategory}
                  treeNodeFilterProp="title"
                  autoClearSearchValue={false}
                  listHeight={180}
                  width={treeSelectWidth}
                  // allowClear={isEditRoleOnView ? false : true}
                />
              </FilterFolderRelative>
            </Col>
          </Row>
          <RightSticky>
            <ToggleContainer>
              <CommonToggle
                background={
                  state.currentToggle === 'left' ? COLORS.PRIMARY : COLORS.WHITE
                }
                onClick={() => state.currentToggle != 'left' ? handleToggleChange('left') : null}
              >
                <CheckListIcon
                  width="20"
                  height="21"
                  color={
                    state.currentToggle === 'left'
                      ? COLORS.PRIMARY
                      : COLORS.GREY_T_80
                  }
                 
                />
              </CommonToggle>
              <CommonToggle
                background={
                  state.currentToggle === 'right'
                    ? COLORS.PRIMARY
                    : COLORS.WHITE
                }
                onClick={() => state.currentToggle != 'right' ? handleToggleChange('right') : null}
               
              >
                <CalendarIcon
                  width="20"
                  height="21"
                  color={
                    state.currentToggle === 'right'
                      ? COLORS.WHITE
                      : COLORS.GREY_T_80
                  }
                />
              </CommonToggle>
            </ToggleContainer>
          </RightSticky>
        </Container>
      )}
      <EventSearch handleSearch={handleSearch} search={state.search} />
      {(currentToggle === 'left' || state.eventStatus == 'DRAFT') && (
        <List
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
          eventList={eventList}
          state={state}
          handleOccurrenceClick={handleOccurrenceClick}
          setState={setState}
          fetchEventsList={fetchEventsList}
          handleSingleEventClick={handleSingleEventClick}
          handleSortByChange={handleSortByChange}
        />
      )}
      {currentToggle === 'right' && (
        <WeekView
          currentWeekStart={currentWeekStart}
          currentWeekEnd={currentWeekEnd}
          calendarRef={calendarRef}
          eventList={eventList}
          setIsDrawerVisible={setIsDrawerVisible}
          isDrawerVisible={isDrawerVisible}
          handleDrawerClose={handleDrawerClose}
          setRenderState={setRenderState}
        />
      )}
    </>
  )
}

export default EventDetails
